export default function resetAuth ({ next, store }) {
    if(store.getters.auth.isAuthenticated){
        store.dispatch('logout');
    }
   
    return true;
}